import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Box,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const ScheduleDialog = ({ selectDate }) => {
    const [open, setOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedTime, setSelectedTime] = useState(dayjs());

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleScheduleNow = () => {
        const now = dayjs();
        console.log("schedule now: ", now.format("YYYY-MM-DD HH:mm"));
        selectDate(now.format("YYYY-MM-DD HH:mm"));
    };

    const handleSchedule = () => {
        const fullDateTime = selectedDate
            .hour(selectedTime.hour())
            .minute(selectedTime.minute());

        console.log("Scheduled for:", fullDateTime.format("YYYY-MM-DD HH:mm"));
        selectDate(fullDateTime.format("YYYY-MM-DD HH:mm"));
        setOpen(false);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                sx={{
                    width: "50%",
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                }}
            >
                <Button
                    variant="contained"
                    size="small"
                    onClick={handleScheduleNow}
                >
                    Schedule Now
                </Button>
                <Button variant="contained" onClick={handleOpen} size="small">
                    Schedule for Later
                </Button>
            </Box>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Schedule Post</DialogTitle>
                <DialogContent>
                    <DatePicker
                        label="Select Date"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} fullWidth margin="normal" />
                        )}
                    />

                    <TimePicker
                        label="Select Time"
                        value={selectedTime}
                        onChange={(newValue) => setSelectedTime(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} fullWidth margin="normal" />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSchedule} variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
};

export default ScheduleDialog;
